import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { useModal } from "../../common/hooks/useModal";
import { DataGrid, GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import StationsService from "../../services/StationsService";

export default function ListAppraiser() {
  const {
    dataModal,
    onCloseModalReset,
    handleChangedModal,
    handleStopSaveModal,
  } = useModal();

  const { t } = useTranslation();
  const [selectedAppraisers, setSelectedAppraisers] = useState<number[]>([]);

  const columns: GridColDef[] = [
    { field: "id", headerName: t("title_header_id") || "", width: 60 },
    { field: "role_string", headerName: t("title_header_role") || "", width: 140 },
    { field: "name", headerName: t("title_header_name") || "", width: 250 },
    { field: "email", headerName: t("title_header_email") || "", width: 230 },
  ];

  const handleSelectionChange = (newSelection) => {
    setSelectedAppraisers(newSelection);
  };

  const handleSubmit = (event?: React.FormEvent<HTMLFormElement>) => {
    event?.preventDefault();

    if (selectedAppraisers.length === 0) {
      toast(t("toast_appraise_empty"), {
        type: "error",
      });
      handleStopSaveModal();
      return;
    }

    const appraisers = dataModal?.data?.appraisers;
    //console.log("appraisers listAppraiser: ", appraisers);
    const selectedAppraisersList = appraisers.filter((appraiser) =>
      selectedAppraisers.includes(appraiser?.id)
    );

    if (selectedAppraisersList.length > 0) {
      dataModal?.data?.setAppraiser(selectedAppraisersList);
      dataModal?.data?.setAppraisers_id(selectedAppraisers.map((a) => a));
    }

    onCloseModalReset();
  };

  useEffect(() => {
    async function fetchInitialAppraisers() {
      if (dataModal?.data?.stationId) {
        try {
          const response = await StationsService.getAppraiserStations(dataModal.data.stationId);
          if (response?.data && Array.isArray(response.data)) {
            setSelectedAppraisers(response.data.map((appraiser: any) => appraiser.id));
          } else if (response?.data?.id) {
            setSelectedAppraisers([response.data.id]);
          }
        } catch {}
      } else if (dataModal?.data?.idAppraiser) {
        setSelectedAppraisers(dataModal.data.idAppraiser);
      }
    }
    fetchInitialAppraisers();

    if (dataModal.loadingBtnSave) {
      handleSubmit();
    }
  }, [dataModal.loadingBtnSave, dataModal.data, dataModal.loadingBtnSave]);

  return (
    <Box>
      <Box
        sx={{ height: 400, width: "100%" }}
        component="form"
        onSubmit={handleSubmit}
      >
        <DataGrid
          rows={dataModal?.data?.appraisers}
          columns={columns}
          pageSize={5}
          checkboxSelection
          disableSelectionOnClick
          selectionModel={selectedAppraisers}
          onSelectionModelChange={(ids) => {
            handleSelectionChange(ids);
          }}
          sx={{ width: "750px" }}
        />
      </Box>
    </Box>
  );
}
